module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("This is a web experiment")]), _vm._v(" "), _c('p', [_vm._v("\n    Sorry, your browser does not support the Web Audio API, which is an integral part of this\n    experiment.\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("\n    Currently supported browsers are\n    "), _c('a', {
    attrs: {
      "href": "http://google.com/chrome",
      "target": "_blank"
    }
  }, [_vm._v("Chrome 10+")]), _vm._v(",\n    "), _c('a', {
    attrs: {
      "href": "http://www.mozilla.org/en-US/firefox/new/",
      "target": "_blank"
    }
  }, [_vm._v("Firefox 25+")]), _vm._v(",\n    "), _c('a', {
    attrs: {
      "href": "http://www.opera.com/",
      "target": "_blank"
    }
  }, [_vm._v("Opera 15+")]), _vm._v(", and\n    "), _c('a', {
    attrs: {
      "href": "http://www.apple.com/au/safari/",
      "target": "_blank"
    }
  }, [_vm._v("Safari 6+")]), _vm._v(".\n  ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3c8423e8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Unsupported.vue
// module id = 162
// module chunks = 2